(function ($) {
$(function () {

    $(document).on('click', '[data-href]', function (e) {
        e.preventDefault();
        const url = $(this).attr('data-href');
        const target = ($(this).attr('target')) ? $(this).attr('target') : '_self';
        window.open(url, target);
    });

});
})(jQuery);


/*****
    Get SVG symbol
    ---
    Usage: "Close" + return_svg('close')
*****/
(function ($) {
$(function () {

    /*****
        Get SVG from sprite
    *****/
    function return_svg(name) {
        const svgDataUrl = window["svg_symbols_url"];
        const svgData = window["svg_symbols"];
        const view_box = svgData[name];
        const the_string = '<svg data-icon="' + name + '" viewBox="' + view_box + '"><use xlink:href="'+ svgDataUrl +'#' + name + '"></use></svg>';

        return the_string;
    }

    window.return_svg = return_svg;

});
})(jQuery);


/*****
    iOS Viewport height fix
*****/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global.vhCheck = factory());
}(this, (function () {
    'use strict';

    function testVh() {
        var fixedTest = document.createElement('div');
        fixedTest.style.cssText = 'position: fixed; top: 0; bottom: 0;';
        document.documentElement.insertBefore(
            fixedTest,
            document.documentElement.firstChild
        );
        var vhTest = document.createElement('div');
        vhTest.style.cssText = 'position: fixed; top: 0; height: 100vh';
        document.documentElement.insertBefore(
            vhTest,
            document.documentElement.firstChild
        );
        var topBottom = fixedTest.offsetHeight;
        var vh = vhTest.offsetHeight;
        var offset = vh - topBottom;
        document.documentElement.removeChild(fixedTest);
        document.documentElement.removeChild(vhTest);
        return offset;
    }
    function updateCssVar(cssVarName, offset) {
        document.documentElement.style.setProperty('--' + cssVarName, offset + 'px');
    }
    function vhCheck(cssVarName) {
        cssVarName = typeof cssVarName === 'string' ? cssVarName : 'vh-offset';
        var offset = testVh();
        if (!offset) return false;
        updateCssVar(cssVarName, offset);
        window.addEventListener(
            'orientationchange',
            function () {
                var newOffset = testVh();
                updateCssVar(cssVarName, newOffset);
            },
            false
        );
        return true;
    }

    return vhCheck;

})));

jQuery.fn.slideFadeToggle = function (speed, easing, callback) {
    return this.animate({ opacity: 'toggle', height: 'toggle' }, speed, easing, callback);
};

jQuery.fn.slideFadeIn = function (speed, easing, callback) {
    return this.animate({ opacity: 'show', height: 'show' }, speed, easing, callback);
};

jQuery.fn.slideFadeOut = function (speed, easing, callback) {
    return this.animate({ opacity: 'hide', height: 'hide' }, speed, easing, callback);
};
